import { MultiSelectContext } from 'App/components/MultiselectProvider/MultiselectProvider';
import openModal from 'App/services/Modal/Modal';
import RequestBuilder from 'Resources/RequestBuilder';

export default function resetScore(
	rb: RequestBuilder,
	entity: string,
	multiselect: MultiSelectContext,
	extraParams?: object
) {
	return openModal('ResetLeadMulti', {
		customerId: Tools.AppService.getCustomerId(),
		filters: rb,
		extraParams,
		entity,
		hideDate: false,
		multiselect: multiselect
	} as any);
}
